module.exports = __webpack_public_path__ + "img/tk.39087dae.svg";